/**
 * @generated SignedSource<<48c898fa7493a1e89bad73a92b07327f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateEmployeeRoleInput = {
  employeeIds?: ReadonlyArray<string> | null;
  name: string;
  teamId: string;
};
export type EmployeeRoleCreateMainMutation$variables = {
  input: CreateEmployeeRoleInput;
};
export type EmployeeRoleCreateMainMutation$data = {
  readonly store: {
    readonly createEmployeeRole: {
      readonly role: {
        readonly employeeCount: number;
        readonly id: string;
        readonly name: string;
        readonly team: {
          readonly id: string;
          readonly name: string;
        };
      };
      readonly store: {
        readonly id: string;
      };
    };
  };
};
export type EmployeeRoleCreateMainMutation = {
  response: EmployeeRoleCreateMainMutation$data;
  variables: EmployeeRoleCreateMainMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "CreateEmployeeRolePayload",
        "kind": "LinkedField",
        "name": "createEmployeeRole",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EmployeeRole",
            "kind": "LinkedField",
            "name": "role",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "employeeCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "store",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmployeeRoleCreateMainMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmployeeRoleCreateMainMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "b18ba0deac6c0c09ba41b147e2e7dc0c",
    "id": null,
    "metadata": {},
    "name": "EmployeeRoleCreateMainMutation",
    "operationKind": "mutation",
    "text": "mutation EmployeeRoleCreateMainMutation(\n  $input: CreateEmployeeRoleInput!\n) {\n  store {\n    createEmployeeRole(input: $input) {\n      role {\n        id\n        name\n        employeeCount\n        team {\n          id\n          name\n        }\n      }\n      store {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c8bd19e3e117694aa843443161bcd94e";

export default node;
